import React, { useEffect, useState } from 'react';
// Las vacaciones de invierno arrancan el 6 de julio de 2026
const TARGET_DATE = new Date('2026-07-06T00:00:00-03:00');
function getTimeLeft() {
  const diff = TARGET_DATE.getTime() - Date.now();
  const clamped = Math.max(diff, 0);
  return {
    days: Math.floor(clamped / (1000 * 60 * 60 * 24)),
    hours: Math.floor(clamped / (1000 * 60 * 60) % 24),
    minutes: Math.floor(clamped / (1000 * 60) % 60),
    seconds: Math.floor(clamped / 1000 % 60)
  };
}
export function Countdown() {
  const [time, setTime] = useState(getTimeLeft);
  useEffect(() => {
    const id = setInterval(() => setTime(getTimeLeft()), 1000);
    return () => clearInterval(id);
  }, []);
  const units = [{
    label: 'Días',
    value: time.days
  }, {
    label: 'Horas',
    value: time.hours
  }, {
    label: 'Min',
    value: time.minutes
  }, {
    label: 'Seg',
    value: time.seconds
  }];
  return <div className="flex justify-center gap-3 md:gap-4" data-id="element-1">
      {units.map(unit => <div key={unit.label} className="bg-slate-900 text-white rounded-2xl w-20 md:w-24 py-4 flex flex-col items-center shadow-lg" data-id="element-2">
          <span className="font-display font-black text-3xl md:text-4xl tabular-nums" data-id="element-3">
            {String(unit.value).padStart(2, '0')}
          </span>
          <span className="text-[11px] md:text-xs uppercase tracking-wider text-slate-400 mt-1" data-id="element-4">
            {unit.label}
          </span>
        </div>)}
    </div>;
}